import React from 'react';

const LiveMap = ({ meetingLocation, participantLocations }) => {
  const centerLat = meetingLocation?.lat || 40.7829;
  const centerLng = meetingLocation?.lng || -73.9654;

  // Create markers string for Google Maps
  const markers = [
    // Meeting location marker (red)
    `markers=color:red%7Clabel:M%7C${centerLat},${centerLng}`,
    // Participant markers (blue)
    ...participantLocations
      ?.filter(p => p?.hasLocation)
      ?.map((p, idx) => `markers=color:blue%7Clabel:${idx + 1}%7C${p?.lat},${p?.lng}`)
  ]?.join('&');

  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${centerLat},${centerLng}&zoom=13&size=800x600&maptype=roadmap&${markers}&key=${import.meta.env?.VITE_GOOGLE_MAPS_API_KEY || 'YOUR_API_KEY'}`;

  return (
    <div className="relative w-full h-full bg-muted rounded-lg overflow-hidden">
      <img
        src={mapUrl}
        alt="Live map showing meeting location and participant positions"
        className="w-full h-full object-cover"
        onError={(e) => {
          // Fallback to embedded map if static map fails
          e.target.style.display = 'none';
          const iframe = document.createElement('iframe');
          iframe.width = '100%';
          iframe.height = '100%';
          iframe.loading = 'lazy';
          iframe.title = 'Meeting Location Map';
          iframe.referrerPolicy = 'no-referrer-when-downgrade';
          iframe.src = `https://www.google.com/maps?q=${centerLat},${centerLng}&z=13&output=embed`;
          e?.target?.parentElement?.appendChild(iframe);
        }}
      />
      <div className="absolute top-4 left-4 bg-card border border-border rounded-lg shadow-md p-3 z-10">
        <h3 className="font-heading text-sm font-semibold text-foreground mb-2">Map Legend</h3>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-destructive rounded-full" />
            <span className="text-xs text-foreground">Meeting Location</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-primary rounded-full" />
            <span className="text-xs text-foreground">Participants</span>
          </div>
        </div>
      </div>
      <div className="absolute bottom-4 left-4 bg-card border border-border rounded-lg shadow-md px-3 py-2 z-10">
        <p className="text-xs text-muted-foreground">
          Tracking {participantLocations?.filter(p => p?.hasLocation)?.length} of {participantLocations?.length} participants
        </p>
      </div>
    </div>
  );
};

export default LiveMap;